<template>
  <div class="categories" :class="{active: !loading}" v-images-loaded:on.progress="imageProgress">
    <transition name="fade">
      <Loading :progress="progress" v-if="loading"/>
    </transition>
    <template v-show="links">
      <router-link v-for="({ name, slug, acf_categories }) in links" :key="slug" :to="`/category/${slug}`" tag="div" class="link">
        <div class="img">
          <img :src="acf_categories.imageCategory.sourceUrl" :srcset="acf_categories.imageCategory.srcSet" :alt="acf_categories.imageCategory.altText">
          <h2>{{ name }}</h2>
        </div>
      </router-link>
    </template>
  </div>
</template>

<script>
import { ALL_CATEGORIES } from '../queries'
import { useQuery, useResult } from '@vue/apollo-composable'

import Loading from '../components/Loading'

import { useImageLoading } from '../compositions/useImageLoading'

export default {
  name: 'categories',
  components: {
    Loading,
  },
  head: {
    title: {
      inner: 'Categories'
    },
  },
  setup() {
    const { result } = useQuery(ALL_CATEGORIES)
    const links = useResult(result, null, data => data.categories.nodes)

    const [ progress, loading, imageProgress ] = useImageLoading()

    return {
      links,
      loading,
      progress,
      imageProgress
    }
  }
}
</script>

<style lang="scss" scoped>
  .categories {
    @extend %container;
  }

  .link {
    cursor: pointer;
    display: flex;
    justify-content: center;
    height: 50vh;
    margin: 25vh 0;
  }

  .img {
    position: relative;
    height: 100%;
    max-width: 100%;
    opacity: 0;
    transition: opacity 0.8s $ease-out;

    .active & {
      opacity: 1;
    }

    &:hover {
      &:after {
        background-color: rgba($white, 0.3);
        transform: translate3d(-4px, 4px, 0);
      }

      img {
        box-shadow: 0 0 20px 4px rgba($black, 0);
        transform: translate3d(-4px, 4px, 0);
      }

      h2 {
        color: $black;
      }
    }

    &:after {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba($white, 0.6);
      transition: background-color 0.8s $ease-out, transform 0.8s $ease-out;
    }

    img {
      max-width: 100%;
      height: 100%;
      object-fit: cover;
      box-shadow: -4px 4px 15px 4px rgba($black, 0.15);
      transition: box-shadow 0.8s $ease-out, transform 0.8s $ease-out;
    }

  }

  h2 {
    @extend %font-bold;
    @extend %link;

    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 2rem;
    transform: translate3d(1rem, 50%, 0);
    opacity: 0;
    letter-spacing: 0.5em;
    text-shadow: 0 0 20px rgba($white, 0.2);
    white-space: nowrap;
    z-index: 1;
    transition: opacity 0.8s 0.4s $ease-out, letter-spacing 1s 0.4s $ease-out, color 0.8s $ease-out;

    .active & {
      opacity: 1;
      letter-spacing: 0;
    }
  }
</style>